import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const Filings = forwardRef(({ permissions: { disableEdit }, data }, ref) => {
  const {
    current: { marketing, id: drugId, ingestedId },
    original: { marketing: originalData },
    ingested: {
      marketing: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);
  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={marketing}
      parentKey="marketing"
      childKey="fillings"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['fillings']}
      ingestionAction={ingestedActions['fillings']}
      parentIngestionAction={ingestedActions}
      ref={ref}
    />
  );
});

Filings.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

Filings.displayName = 'Filings';

export default Filings;
